import { createAPIActionEntity } from "./actionUtils.js";

export const CONFIG_FILE = `config/config.properties`;

export const CONFIG = createAPIActionEntity("CONFIG");

export const STARTUP = createAPIActionEntity("STARTUP");
export const ENDPOINTS = createAPIActionEntity("ENDPOINTS");

export const ACCOUNT = createAPIActionEntity("ACCOUNT");
export const PASSWORD = createAPIActionEntity("PASSWORD");
export const PASSWORD_REQUEST = "PASSWORD_REQUEST";
export const PASSWORD_RESET = "PASSWORD_RESET";
export const USERNAME = createAPIActionEntity("USERNAME");
export const USERNAME_RECOVERY = "USERNAME_RECOVERY";
export const VERIFICATION_RECOVERY = "VERIFICATION_RECOVERY";

export const CORE = createAPIActionEntity("CORE");
export const PROVIDERS = createAPIActionEntity("PROVIDERS");
export const SERVICES = createAPIActionEntity("SERVICES");
export const REGIONS = createAPIActionEntity("REGIONS");
export const ZONES = createAPIActionEntity("ZONES");
export const IMAGES = createAPIActionEntity("IMAGES");
export const SIZES = createAPIActionEntity("SIZES");
export const TIMEZONES = createAPIActionEntity("TIMEZONES");
export const INVITES = createAPIActionEntity("INVITES");

export const PROJECTS = createAPIActionEntity("PROJECTS");
export const CONNECTIONS = createAPIActionEntity("CONNECTIONS");
export const ESTIMATES = createAPIActionEntity("ESTIMATES");
export const SCHEDULE_ACTIONS = createAPIActionEntity("SCHEDULE_ACTIONS");

export const RESOURCES = createAPIActionEntity("RESOURCES");
export const WORKSTATIONS = createAPIActionEntity("WORKSTATIONS");
export const DISPLAY_GATEWAYS = createAPIActionEntity("DISPLAY_GATEWAYS");
export const VPN_GATEWAYS = createAPIActionEntity("VPN_GATEWAYS");
export const CONTAINERS = createAPIActionEntity("CONTAINERS");
export const DATABASES = createAPIActionEntity("DATABASES");
export const NODES = createAPIActionEntity("NODES");
export const SNOWFLAKES = createAPIActionEntity("SNOWFLAKES");
export const SSH_KEYS = createAPIActionEntity("SSH_KEYS");

export const PUSHED = createAPIActionEntity("PUSHED");
export const DOWNLOADS = createAPIActionEntity("DOWNLOADS");

export const USERS = createAPIActionEntity("USERS");
export const GROUPS = createAPIActionEntity("GROUPS");
export const SCHEDULES = createAPIActionEntity("SCHEDULES");
export const INVOICES = createAPIActionEntity("INVOICES");
export const CHARGE = createAPIActionEntity("CHARGE");
export const USAGE = createAPIActionEntity("USAGE");
export const MEASUREMENTS = createAPIActionEntity("MEASUREMENTS");

export const SIGNUP = createAPIActionEntity("SIGNUP");
export const VERIFY = createAPIActionEntity("VERIFY");

export const ENTITIES = createAPIActionEntity("ENTITIES");

export const API_REQUEST = "API_REQUEST";
export const API_SUCCESS = "API_SUCCESS";
export const API_RESET = "API_RESET";
export const API_ERROR = "API_ERROR";
export const API_ERROR_MODAL = "API_ERROR_MODAL";
export const API_ERROR_NEXT = "API_ERROR_NEXT";
export const API_ERROR_RESET = "API_ERROR_RESET";

export const OPERATION = "OPERATION";

export const HELP_WIDGET = {
  OPEN: "HELP_WIDGET_OPEN",
  CLOSE: "HELP_WIDGET_CLOSE",
  TOGGLE: "HELP_WIDGET_TOGGLE",
  UPDATE: "HELP_WIDGET_UPDATE",
  RESET: "HELP_WIDGET_RESET"
};

export const WATCHERS = {
  READY: "WATCHERS_READY",
  NOT_READY: "WATCHERS_NOT_READY",
  RESET: "WATCHERS_RESET"
};
